import { components } from "@/api-schema";
import { RelocationOrderTransportMethod } from "@/api-schema-enums";
import { RowAction } from "@/components/ui/table-row-actions";
import {
  OrderVariantRoles,
  buildB2BOwnAxleActions,
  buildB2BTransportCompanyActions,
  buildB2EOwnAxleActions,
  buildB2ETransportCompanyActions,
  buildE2BOwnAxleActions,
  buildE2BTransportCompanyActions,
} from "./builders/relocation-order-variant-action-builders";
import { RelocationOrderActionsContext } from "./relocation-order-actions-context";

type RelocationOrder = components["schemas"]["RelocationOrder"];

export function buildActionsForOrder(
  order: RelocationOrder,
  userBranchesUuids: string[],
  context: RelocationOrderActionsContext,
): RowAction[] {
  const roles: OrderVariantRoles = {
    isOriginBranch: order.originBranch?.uuid ? userBranchesUuids.includes(order.originBranch.uuid) : false,
    isDestinationBranch: order.destinationBranch?.uuid
      ? userBranchesUuids.includes(order.destinationBranch.uuid)
      : false,
  };

  const hasOriginBranch = order.originBranch !== null;
  const hasDestinationBranch = order.destinationBranch !== null;
  const isOwnAxle = order.transportMethod === RelocationOrderTransportMethod.OwnAxle;

  if (hasOriginBranch && hasDestinationBranch) {
    return isOwnAxle
      ? buildB2BOwnAxleActions(order, roles, context)
      : buildB2BTransportCompanyActions(order, roles, context);
  }

  if (hasOriginBranch && !hasDestinationBranch) {
    return isOwnAxle
      ? buildB2EOwnAxleActions(order, roles, context)
      : buildB2ETransportCompanyActions(order, roles, context);
  }

  // !hasOriginBranch && hasDestinationBranch (E2B)
  return isOwnAxle
    ? buildE2BOwnAxleActions(order, roles, context)
    : buildE2BTransportCompanyActions(order, roles, context);
}
